/**
 * I18n resolves boolean values.
 * @param {Boolean} value - Boolean value to be i18n resolved.
 * @param {String} options.i18nGetter - i18n translation function.
 */
function resolve(value, options) {
  // Get parameters
  const {
    i18nGetter
  } = options;

  // Resolve value
  let resolvedValue;
  if (value === true) {
    resolvedValue = i18nGetter('trueValue', 'true');
  } else if (value === false) {
    resolvedValue = i18nGetter('falseValue', 'false');
  } else {
    resolvedValue = i18nGetter('unsetValue', '-');
  }

  // Return resolved value
  return [resolvedValue];
}
export default {
  resolve
};